import React, { useState, useEffect } from 'react';
import loadStripeJs from '../utils/loadStripeJs';
import axios from 'axios';
import Loading from '../components/Loading';
import moment from 'moment';
import StripeCardForm from '../components/StripeCardForm';

const UserSubscription = props => {
  const [stripeJS, updateStripe] = useState(false);
  const [subscription, setSubscription] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [changePaymentMethod, setChangePaymentMethod] = useState(false);
  const [subscriptionError, setSubscriptionError] = useState('');
  const [isPetSure, setPetSure] = useState(false);

  //load stripeJS and subscription infromations
  useEffect(() => {
    async function loadSubscription() {
      if (props.user.customer_id) {
        setLoading(true);

        //load Customer payment method
        await axios
          .get('/user/userPayment/' + props.user.customer_id)
          .then(result => {
            // console.log(result.data);
            setPaymentMethod(result.data);
          });

        //load Subscription
        await axios.get('/user/subscription/' + props.user.id).then(result => {
          if (result.data.error) {
            //error returned
          } else {
            setSubscription(result.data);
          }
        });

        setLoading(false);
      } else {
        //is PetSure subscription
        setPetSure(true);

        //load coupon end date which is subscription end date;
        const subscriptionData = Object.assign({}, props.user.subscription);
        const { subs_id } = subscriptionData;
        const couponCode = subs_id.split('_')[1];

        await axios.post('/pay/coupon', { couponCode }).then(res => {
          subscriptionData['coupon'] = res.data;
        });

        setSubscription(subscriptionData);
      }
    }

    console.log('loading subscription data');
    loadStripeJs(() => updateStripe(true));
    loadSubscription();
    //eslint-disable-next-line
  }, []);

  async function cancelSubscription() {
    setLoading(true);
    await axios
      .post('/user/cancelSubscription', { subscription_id: subscription.id })
      .then(result => {
        if (result.data.err) {
        } else {
          setSubscription(result.data);
          setLoading(false);
        }
      });
  }

  //update user payment with new card
  async function doChangePaymentMethod(Stripe = null) {
    console.log('change payment method triggered');
    if (Stripe === null) {
      console.log(' no Stripe');

      return;
    }
    // setLoading(true);
    await Stripe.createToken().then(async payload => {
      if (payload.hasOwnProperty('error')) {
        console.log(payload.error);
        setSubscriptionError(payload.error.message);
        return;
      }
      setLoading(true);
      await axios
        .post('user/updatePayment', {
          customer: props.user.customer_id,
          payload
        })
        .then(result => {
          console.log(result.data);
          setPaymentMethod(result.data);
        });
      setLoading(false);
    });
  }

  const SubscriptionConsultations = props.user.subscription.consultations;
  let subs_usage = 0;
  if (SubscriptionConsultations !== null) {
    subs_usage = JSON.parse(SubscriptionConsultations).length;
  }

  //Minimal Display for PetSure subscription
  if (isPetSure) {
    return (
      <div>
        <h1>Subscription</h1>
        <h4>Pet Sure 6 months Membership </h4>
        {subscription && subscription.coupon && subscription.coupon.end && (
          <p>End Date: {moment(subscription.coupon.end).format('ll')}</p>
        )}
        {/* End Date: {moment(subscription.coupon.end).format('lll')} */}
      </div>
    );
  }

  return (
    <div>
      <h1>Subscription</h1>
      {loading ? (
        <Loading />
      ) : (
        <div className='row'>
          <div className='col-sm-6 subscription-detail'>
            <h4 style={{ textDecoration: 'underline' }}>12 Month Membership</h4>
            {subscription.hasOwnProperty('id') && (
              <>
                <p>
                  <strong>Subscription end date: </strong>
                  {moment.unix(+subscription.current_period_end).format('LL')}
                </p>
                <p>
                  <strong>Usage until today: </strong>
                  {subs_usage}/{props.consultationLimit}
                </p>

                {/* Cancel subscription option */}
                {subscription.cancel_at_period_end ? (
                  <p className='alert alert-warning'>
                    Your subscription will end at the end date stated above.
                  </p>
                ) : (
                  <button
                    className='btn btn-transparent'
                    onClick={cancelSubscription}
                  >
                    Cancel Subscription
                  </button>
                )}
              </>
            )}
          </div>
          <div className='col-sm-6 payment-detail'>
            {paymentMethod.hasOwnProperty('object') &&
              paymentMethod.object === 'card' && (
                <>
                  <h4 style={{ textDecoration: 'underline' }}>
                    Payment Method{' '}
                    {
                      <span>
                        <i
                          className={`fa fa-${
                            changePaymentMethod ? 'times' : 'edit'
                          }`}
                          onClick={() => {
                            setChangePaymentMethod(!changePaymentMethod);
                          }}
                          title={changePaymentMethod ? 'Cancel' : 'Change'}
                          style={{ cursor: 'pointer', color: '#00C7FA' }}
                        />
                      </span>
                    }
                  </h4>
                  {!changePaymentMethod ? (
                    <>
                      <p>
                        <b>Card: </b>
                        {paymentMethod.brand}
                      </p>
                      <p>
                        <b>Number: </b>**** **** **** {paymentMethod.last4}
                      </p>
                      <p>
                        <b>Expiry: </b>
                        {paymentMethod.exp_month}/{paymentMethod.exp_year}
                      </p>
                    </>
                  ) : (
                    <div className='stripeForm'>
                      {stripeJS && (
                        <StripeCardForm
                          buttonText='Update'
                          processPayment={doChangePaymentMethod}
                          processing={loading}
                        />
                      )}
                    </div>
                  )}
                </>
              )}
          </div>
          {subscriptionError !== '' && (
            <div className='col-sm-12'>
              <div className='alert alert-danger'>
                <p>{subscriptionError}</p>
                <button
                  onClick={() => {
                    setSubscriptionError('');
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UserSubscription;
